// extracted by mini-css-extract-plugin
export default {"CardAttributes":"CardAttributes","CardAttribute":"CardAttribute","CardAttribute--Label":"CardAttribute--Label","CardAttribute--Display":"CardAttribute--Display"};